module.exports = __webpack_public_path__ + "img/mine.dd47734d.png";